import { Outlet, useLocation, useNavigate, useSearchParams } from "react-router"
import { useTranslation } from "react-i18next"
import { BottomNavbar, WalletIcon, NFTIcon, SettingsIcon } from "@tutellus/tutellus-components"
import { SettingsModal } from "../../components/modules/SettingsModal"
import { Topbar } from "../../components/Layout/Topbar"
import { Footer } from "../../components/Layout/Footer"
import styles from "./index.module.css"

export function Component() {
  const { pathname: currentRoute } = useLocation()
  const { t } = useTranslation("common")
  const navigate = useNavigate()

  const [searchParams, setSearchParams] = useSearchParams()
  const settingsParam = searchParams.get("settings") === "true"

  const handleRouteChange = (url: string) => {
    if (url.startsWith("http")) {
      window.open(url, "_blank")
    } else {
      navigate(url)
    }
  }

  const toggleSettings = () => {
    if (settingsParam) {
      searchParams.delete("settings")
    } else {
      searchParams.set("settings", "true")
    }
    setSearchParams(searchParams)
  }

  const menuItemsBottom = [
    {
      label: t("navigation.poaps.title"),
      tooltip: t("navigation.poaps.title"),
      description: t("navigation.poaps.description"),
      url: "/",
      icon: NFTIcon,
    },
    {
      label: t("navigation.wallet.title"),
      tooltip: t("navigation.wallet.title"),
      description: t("navigation.wallet.description"),
      url: "/wallet",
      icon: WalletIcon,
    },

    {
      label: t("settingsMenu"),
      tooltip: t("settingsMenu"),
      description: t("settingsDescription"),
      icon: SettingsIcon,
      onClick: toggleSettings,
    },
  ]

  const bottomItems = [
    {
      label: t("navigation.poaps.title"),
      url: "/",
      icon: NFTIcon,
    },
    {
      label: t("navigation.wallet.title"),
      url: "/wallet",
      icon: WalletIcon,
    },
    {
      label: t("settingsMenu"),
      icon: SettingsIcon,
      onClick: toggleSettings,
    },
  ]

  return (
    <>
      <div className={styles.layoutContainer}>
        <header className={styles.layoutHeader}>
          <Topbar />
        </header>
        <main className={styles.layoutMain}>
          <Outlet />
        </main>
        <div className={styles.layoutFooter}>
          <Footer />
          <div className={styles.bottomNavBar}>
            <BottomNavbar
              menuItems={menuItemsBottom}
              bottomItems={bottomItems}
              currentRoute={currentRoute}
              onRouteChange={handleRouteChange}
              onOpenChange={undefined}
            />
          </div>
        </div>

        {settingsParam && (
          <SettingsModal
            onClose={() => {
              searchParams.delete("settings")
              setSearchParams(searchParams)
            }}
          />
        )}
      </div>
    </>
  )
}
